import * as z from "zod";
import {TaxCorporationSimpleResModel} from "./TaxCorporationSimpleResModel";

const schema = z.object({
	content: z.array(TaxCorporationSimpleResModel.model).default([]),
	currentPage: z.number().default(0),
	pageSize: z.number().default(20),
	totalCount: z.number().default(0),
	totalPages: z.number().default(0)
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxCorporationSimpleSearchResModel = {schema, model};
export type ITaxCorporationSimpleSearchResModel = z.infer<typeof TaxCorporationSimpleSearchResModel.model>;

export const DEFAULT_TAX_CORPORATION_SIMPLE_SEARCH_RES: ITaxCorporationSimpleSearchResModel = {
	content: [],
	currentPage: 0,
	pageSize: 20,
	totalCount: 0,
	totalPages: 0
};
